import classNames from 'classnames';

import styles from './Panel.module.scss';

interface Props {
  title?: string;
  strongHeader?: boolean;
  centerBody?: boolean;
  children?: React.ReactNode;
}

const Panel: React.FC<Props> = ({
  title,
  children,
  strongHeader = false,
  centerBody = false,
}) => (
  <div className={styles.panel}>
    {title && (
      <div
        className={classNames(styles.header, {
          [styles.strongHeader]: strongHeader,
        })}
      >
        <div className={styles.headerInner}>
          <h2 className={styles.headerTitle}>{title}</h2>
        </div>
      </div>
    )}
    <div
      className={classNames(styles.body, {
        [styles.centerBody]: centerBody,
      })}
    >
      {children}
    </div>
  </div>
);

export default Panel;
